var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_3501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1208 3.11787C13.5098 3.41725 12.9111 3.53884 12.2879 3.72275C11.6029 2.94985 10.5875 2.90708 9.61173 3.27245C8.63598 3.63782 7.99688 4.53109 8.01093 5.55572V6.16671C6.02827 6.21742 4.26251 5.31438 3.12301 3.72275C3.12301 3.72275 0.567846 8.26424 5.56697 10.4436C4.4232 11.2056 3.28248 11.7194 1.90103 11.6656C3.92218 12.7672 6.1248 13.1461 8.03171 12.5925C10.2191 11.9571 12.0166 10.3178 12.7064 7.86221C12.9122 7.11538 13.0143 6.34381 13.0101 5.56916C13.0088 5.41703 13.9327 3.8755 14.1208 3.11726V3.11787Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6638,
    height: 14.6638,
    fill: "white",
    transform: "translate(0.679039 0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5d2db49b2a3b634df4d5f7e096bf3e0a.svg";
export { ForwardRef as ReactComponent };